<template>
    <div v-if="isOpen" class="modal-overlay" @click="close">
      <div class="modal-content" @click.stop>
        <h3>Настройки колонок</h3>

        <!-- Кнопки выбрать все и сбросить все -->
        <div class="column-buttons">
            <button @click="selectAll">Выбрать все</button>
            <button @click="clearAll" class="close-button">Сбросить все</button>
        </div>

        <div class="column-selection">
          <label v-for="(column, index) in columns" :key="index">
            <input 
              type="checkbox" 
              :value="column.key" 
              v-model="selectedColumns" 
            />
            {{ column.label }}
          </label>
        </div>

        <div class="modal-buttons">
          <button @click="applySettings">Применить</button>
          <button @click="close" class="close-button">Закрыть</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import { ref, watch } from 'vue';

export default {
  name: 'ColumnSettingsModal',
  props: ['isOpen', 'columns', 'savedColumns'],
  emits: ['updateColumns', 'close'],
  setup(props, { emit }) {
    // Состояние для выбранных колонок
    const selectedColumns = ref(props.savedColumns || []);

    // Применение настроек и сохранение выбранных колонок в localStorage
    const applySettings = () => {
      localStorage.setItem('selectedColumns', JSON.stringify(selectedColumns.value));
      emit('updateColumns', selectedColumns.value);
      close();
    };

    // Закрытие модального окна
    const close = () => {
      emit('close');
    };

    // Выбрать все колонки
    const selectAll = () => {
      selectedColumns.value = props.columns.map(column => column.key);
    };

    // Сбросить выбор колонок
    const clearAll = () => {
      selectedColumns.value = [];
    };

    // Слежение за изменениями пропса savedColumns
    watch(() => props.savedColumns, (newVal) => {
      selectedColumns.value = newVal;
    });

    return {
      selectedColumns,
      applySettings,
      close,
      selectAll,
      clearAll
    };
  }
};
</script>

<style scoped>
h3{
    text-align: center;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 400px;
    width: 100%;
}

.column-selection {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.column-buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.modal-buttons {
    display: flex;
    justify-content: space-between;
}

button {
    padding: 8px 15px;
    background-color: #007BFF;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.close-button{
    background-color: #c33446;
}

button:hover {
    background-color: #0056b3;
}
</style>
